import React from 'react';

import classes from './HeaderWrapper.module.scss';

interface Props {
    children: React.ReactNode;
    className?: string;
}

export const HeaderWrapper = ({ children, className }: Props) => {
    const combinedClassName = className ? `${classes.headerWrapper} ${className}` : classes.headerWrapper;
    return <div className={combinedClassName}>{children}</div>;
};
